import * as React from 'react'
import { SVGProps } from 'react'

const SvgCheckThick = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 426.667 426.667" {...props}>
    <path d="M366.933 42.667 149.333 262.4l-89.6-89.6L0 232.533 149.333 384l277.334-279.467z" />
  </svg>
)

export default SvgCheckThick
